import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  finishDateFieldWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
  finishDateInput: {
    flex: 1,
    minWidth: 0,
  },
  finishDateTooltipButton: {
    marginTop: 0,
  },
  dateFieldsRow: {
    display: 'flex',
    gap: theme.spacing(1),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  dateFieldItem: {
    flex: 1,
    minWidth: 0,
    width: '100%',
  },
  buttonActionWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    padding: theme.spacing(1),

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  radarChartContainer: {
    ...theme.mixins.appContainer,
    width: '100%',
    padding: 0,
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  chartTitle: {
    ...theme.mixins.appLabel,
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
}));
